/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import starBgGradient from "assets/images/starBgGradient.svg";
import ufo from "assets/images/ufo.png";
import { Button } from "components/base/_common/index";
import styles from "./ErrorPage.module.scss";

export default class extends React.Component {
  render() {
    return (
      <div className={styles.errorPage} style={{ backgroundImage: `url(${starBgGradient})` }}>
        <div>
          <div className={styles.errorPageContent}>
            <img src={ufo} alt="space ship alien" />
            <div className={styles.errorPageText}>
              <h2 className={styles.textHeading}>
                <Trans i18nKey="ErrorPage404.title">Error 404 - Page not found</Trans>
              </h2>
              <h3 className={styles.textSubHeading}>
                <Trans i18nKey="ErrorPage404.subTitle">Oh no! Our webpage has been kidnapped!</Trans>
              </h3>
              <div className={styles.textContent}>
                <Trans i18nKey="ErrorPage404.textContent">
                  <p>There's nothing we can do right now...</p>
                  <p>Lets retreat to our homepage.</p>
                </Trans>
                <div>
                  <Link to="/">
                    <Button>
                      <Trans i18nKey="ErrorPage404.buttonAction">Back To Home</Trans>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
